import React, { useState, useEffect, useCallback, useContext } from 'react';
import { Row, Col, Stack, Button } from 'react-bootstrap';
import MapView from './parts/MapView';
import CardItem from './parts/CardItem';
import { NotifyModalView, NotifyButtonView } from './parts/NotifySettingView';
import DeviceService, { DeviceItem } from '#/services/DeviceService';
import { SpinnerView } from './parts/SpinnerView';
import { useParams, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { UserContext } from './App';

function OwnerInfo() {
  const ctx = useContext(UserContext);
  const [device, setDevice] = useState<DeviceItem>();
  const { id } = useParams();
  const [emailSetting, setEmailSetting] = useState<boolean>(false);
  const [smsSetting, setSmsSetting] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    new DeviceService('owner', ctx.userInfo!).getInfo(id!).then(
      (res) => {
        setDevice(res);
      },
      (err) => {
        if (err.response && err.response.status === 401) {
          navigate(0);
        }
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onNotifyChange = useCallback(
    (value) => {
      setDevice({
        ...device!,
        notify: {
          ...device!.notify,
          ...value,
        },
      });
    },
    [device]
  );

  if (!device) {
    return <SpinnerView />;
  }

  return (
    <>
      <header className="page-header page-header-dark bg-gradient-primary-to-secondary pb-10">
        <div className="container-xl px-4">
          <div className="page-header-content pt-1">
            <div className="row align-items-center justify-content-between">
            </div>
          </div>
        </div>
      </header>
      <div className="container-xl px-4 mt-n10">
        <div className="card mb-4">
          <div className="card-body">
            <Row>
              <Col>
                <Stack direction="horizontal">
                  <span>親機ID</span>
                  <span>：</span>
                  <span>{device.id}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span>識別ID</span>
                  <span>：</span>
                  <span>{device.device_id}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span>設置日</span>
                  <span>：</span>
                  <span>{dayjs(device.created_at).format('YYYY/MM/DD')}</span>
                </Stack>
                <Stack direction="horizontal">
                  <span>最終更新日</span>
                  <span>：</span>
                  <span>
                    {dayjs(device.updated_at).format('YYYY/MM/DD HH:mm:ss')}
                  </span>
                </Stack>
                <Stack direction="horizontal">
                  <span>最終センサー更新日</span>
                  <span>：</span>
                  <span>
                    {device.sensor?.receive_at
                      ? dayjs(device.sensor?.receive_at).format(
                          'YYYY/MM/DD HH:mm:ss'
                        )
                      : ''}
                  </span>
                </Stack>
              </Col>
              <Col className="text-end" xs="3">
                <Button
                  variant="warning"
                  className="w-100"
                  href={`/owner/modify/${device.id}`}
                >
                  変更
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col>
                <CardItem title="設置位置">
                  <div style={{height:'300px'}}>
                    <MapView {...device.location} />
                  </div>
                </CardItem>
              </Col>
            </Row>
            <Row className="mt-4">
              <Col>
                <CardItem title="お知らせ設定">
                  <NotifyButtonView
                    title="メール"
                    verifierd={device.notify.email_verifier}
                    onEnable={() => setEmailSetting(true)}
                    onDisable={() => {
                      setEmailSetting(true);
                    }}
                  />
                  <NotifyButtonView
                    title="ＳＭＳ"
                    verifierd={device.notify.sms_verifier}
                    onEnable={() => setSmsSetting(true)}
                    onDisable={() => {
                      setSmsSetting(true);
                    }}
                  />
                </CardItem>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <NotifyModalView
        notify_id={String(device.id)}
        notify_type={device.type}
        notify_kind="email"
        title="メールアドレス"
        isShow={emailSetting}
        isVerify={device.notify.email_verifier}
        onClose={() => {
          setEmailSetting(false);
        }}
        onSubmit={onNotifyChange}
      />
      <NotifyModalView
        notify_id={String(device.id)}
        notify_type={device.type}
        notify_kind="sms"
        title="電話番号"
        isShow={smsSetting}
        isVerify={device.notify.sms_verifier}
        onClose={() => {
          setSmsSetting(false);
        }}
        onSubmit={onNotifyChange}
      />
    </>
  );
}

export default OwnerInfo;
